import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	createChildHeading: {
		id: 'business-list.common.onboarding-spotlight-wrapper.create-child-heading',
		defaultMessage: 'Now break it down',
		description: 'Heading of a Spotlight around issue field plus icon.',
	},
	createChildBody: {
		id: 'business-list.common.onboarding-spotlight-wrapper.create-child-body',
		defaultMessage: 'Splitting the work into smaller tasks makes it easier to prioritize each one.',
		description: 'Content of a Spotlight around issue field plus icon.',
	},
	createFieldHeading: {
		id: 'business-list.common.onboarding-spotlight-wrapper.create-field-heading',
		defaultMessage: 'Add a new field',
		description: 'Heading of a Spotlight around issue field plus icon.',
	},
	createFieldBody: {
		id: 'business-list.common.onboarding-spotlight-wrapper.create-field-body',
		defaultMessage:
			'Add as many fields as you require in order to capture the right information for each piece of work.',
		description: 'Content of a Spotlight around issue field plus icon.',
	},
	dismiss: {
		id: 'business-list.common.spotlight-wrapper.dismiss-non-final',
		defaultMessage: 'OK',
		description: 'Button text within the spotlight to dismiss the spotlight.',
	},
});
